module.exports = __webpack_public_path__ + "static/front/img/instagram3.318a0f85.jpg";